/**
 * Builds key for the analytics data.
 *
 * @param {object }params Params for the key.
 * @returns {string}                 Key.
 */
export const getAnalyticsDataKey = (params = {}) => {
    const key = JSON.stringify(
        Object.entries(params).map(([key, value]) => `${key}:${value}`).sort()
    );

    return key;
};
